<template class="blue">
        <v-card flat tile dark class="mb-4 blue">
          <v-toolbar flat dark class="blue"  >
            <v-toolbar-title class="mx-auto">{{title}}</v-toolbar-title>
          </v-toolbar>
          <v-container fluid grid-list-lg >
            <v-layout row wrap>       
              <v-flex xs12>
                <div class="text-xs-center" id="valButtons">
                  <div class="headline"></div>
                  <v-flex xs10 text-xs-center mx-auto>
                    <div v-for="item in activityTypes" :key="item.text">
                      <div v-if="item.actId==postActId">
                        <v-btn block xs6 round flat color="white" :to="'/val'">{{item.text}}</v-btn>
                      </div>
                    </div>
                    <div v-for="item in activityIntensityTypes"  :key="item.index">
                      <div v-if="item.actId==postActId">
                        <v-btn block xs6 round light :to="'/val/'+item.actId+'/'+item.value">{{item.name}}</v-btn>
                      </div>
                    </div>
                  </v-flex>
                </div>
              </v-flex>            
            </v-layout>
          </v-container>
        </v-card> 

</template>

<script>

import AppConst from '../AppConst.js'

var actObj=AppConst.activityTypesDefaults;
var actIntensityObj=AppConst.activityIntensityTypesDefaults;

export default {
  data () {
    return {
      title: 'Select Intensity',
      activityTypes: actObj,
      activityIntensityTypes: actIntensityObj
    }
  },
  props: [ 
    'postActId',   
  ]
  
}

</script>









// WEBPACK FOOTER //
// src/components/val/ValIntensity.vue